import { ICartEntry } from '@rbi-ctg/menu';
import { IUseLoyaltyRewardsFeedback } from 'state/loyalty/hooks/types';

type UseLoyaltyRewardsFeedback = (cartEntries: ICartEntry[]) => IUseLoyaltyRewardsFeedback;

export const useLoyaltyRewardsFeedback: UseLoyaltyRewardsFeedback = () => {
  return {} as IUseLoyaltyRewardsFeedback;
};
